import AbstractController from '../../../services/abstractController';
import LoginService from '../../../../app/services/LoginService';

export default class RequireAuthenticationController extends AbstractController {

  private loginService = new LoginService();

  constructor() {
    super();
  }

  autenticar(password: any, accept: any) {
    this.start();
    this.loginService.login(this.getUser().preferredUsername, password).then(res => {
      this.stop();
      accept();
    }).catch(err => {
      this.stop();
    })

  }

}
